import PropTypes from 'prop-types';
import React from 'react';
import globalStyles from '../../globals.scss';
import { Icon } from 'semantic-ui-react';
import styles from './Dthc.scss';
import '../../../lib/stylesheets/SlideTransition.scss';
import onClickOutside from 'react-onclickoutside';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import styleVariables from '../../variables';

const Dthc = class Dthc extends React.Component {

  static propTypes = {
    mobile: PropTypes.func.isRequired,
    desktop: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    hoverClass: PropTypes.string,
    initiallyOpen: PropTypes.bool,
    iconStyle: PropTypes.object,
    handleClickOutside: PropTypes.bool,
    style: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      editing: false,
      openingModal: false
    };
    this.onSelect = this.onSelect.bind(this);
    this.onDeselect = this.onDeselect.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onTap = this.onTap.bind(this);
    this.closeHandler = this.closeHandler.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    if (this.props.initiallyOpen) this.setState({ editing: true });
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  onClick() {
    this.setState({ editing: true });
  }

  onTap() {
    if (this.state.selected) {
      this.setState({ editing: true, selected: false, openingModal: true });
      setTimeout(() => {
        this.setState({ openingModal: false });
      }, 300);
    }
  }

  handleClickOutside() {
    if (!this.state.openingModal && this.props.handleClickOutside) {
      this.setState({ editing: false, selected: false });
    }
  }

  onSelect() {
    this.setState({ selected: true });
  }

  onDeselect() {
    this.setState({ selected: false });
  }

  closeHandler() {
    this.setState({ editing: false, selected: false });
  }

  updateWindowDimensions() {
    this.setState({ window: { width: window.innerWidth, height: window.innerHeight } });
  }

  render() {
    const { mobile: Mobile, desktop: Desktop, children: Children, ...rest } = this.props;
    const desktopView = this.state.editing ?
      <Desktop
        closeHandler={this.closeHandler}
        {...rest}
      /> :
      Children;
    const mobileView = this.state.editing ?
      <ReactCSSTransitionGroup
        transitionName='slide'
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}
      >
        <Mobile
          {...rest}
          open={this.state.editing}
          closeHandler={this.closeHandler}
        />
      </ReactCSSTransitionGroup> :
      Children;

    const editIconVisible = this.state.selected && !this.state.editing ?
      globalStyles.visible :
      globalStyles.invisible;

    const hoverClass = (() => {
      if (this.state.selected && !this.state.editing) {
        return this.props.hoverClass ? this.props.hoverClass : styles.hover;
      }
      return '';
    })();
    const iconClass = [styles.cardEdit, editIconVisible].join(' ');

    return (
      <div style={this.props.style}>
        {this.state.window.width >= styleVariables.tabletBreakpoint &&
          <div
            onMouseOver={this.onSelect}
            onMouseOut={this.onDeselect}
            onClick={this.onClick}
            className={globalStyles.desktop}
            style={{ position: 'relative' }}
          >
            <div className={hoverClass}>
              {desktopView}
            </div>
            <Icon className={iconClass} style={this.props.iconStyle} name='write' />
          </div>
        }
        {this.state.window.width < styleVariables.tabletBreakpoint &&
          <div
            onMouseOver={this.onSelect}
            onMouseOut={this.onDeselect}
            onClick={this.onTap}
            className={globalStyles.mobile}
            style={{ position: 'relative' }}
          >
            <div className={hoverClass}>
              {mobileView}
            </div>
            <Icon className={iconClass} style={this.props.iconStyle} name='write' />
          </div>
        }
      </div>
    );
  }

};

export default onClickOutside(Dthc);



// WEBPACK FOOTER //
// ./webpack/components/Modules/Dthc/Dthc.js